import api from '@/api'

export function beat () {
  return api({
    url: '/checkLogin',
    method: 'GET'
  })
}
